// extracted by mini-css-extract-plugin
export default {"timeline-item__body-text":"styles_timeline-item__body-text__-vWUj","timeline-item--text-only":"styles_timeline-item--text-only__gGj7L"};